export default "__VITE_ASSET__BW8n16D5__"